import { useEffect } from "react";
import { Box, Text } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import Statistics from "./Statistics";
import { handleGetDashboardData } from "../../redux/api_calls/apiCalls";

export default function Settings() {
  const slider = useSelector((state) => state.sliderState.sliderOpen);
  const dispatch = useDispatch();
  const { statisticParticipantsData,isStatisticParticipantsLoading } = useSelector(
    (state) => state.statisticParticipantsData
  );
  useEffect(() => {
    dispatch(handleGetDashboardData());
  }, [dispatch,statisticParticipantsData]);
  
  return (
    <Box
      flexGrow="1"
      d="flex"
      justifyContent="flex-start"
      alignItems="center"
      flexDirection="column"
      minH="90vh"
      pl={[
        "0",
        "0",
        "0",
        slider ? (window.innerWidth < 1400 ? "18vw" : "13vw") : "7.5vw",
      ]}
      transition="all 350ms ease"
    >
      <Box
        width={["95%", "95%", "90%", "85%"]}
        justifyContent={["center", "center", "flex-start", "flex-start"]}
        alignItems={["center", "center", "flex-start", "flex-start"]}
        d="flex"
        mb="2rem"
        flexDirection="column"
      >
        <Text
          fontSize={["20px", "25px", "30px", "40px"]}
          d={["none", "none", "none", "flex"]}
          fontWeight="900"
          style={{ fontFamily: "Mulish, sans-serif" }}
          mb="2rem"
        >
          Dashboard
        </Text>
        <Statistics statisticsData={statisticParticipantsData} isLoading={isStatisticParticipantsLoading}/>
        <Box
          width="100%"
          d="flex"
          justifyContent="space-between"
          flexDir="column"
        >
          
        
            <Box
                w='100%'
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                mb='1rem'
                px='1rem'
            >
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='16.6%'>Participants</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='16.6%' textAlign='center'>Class Schedules</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='16.6%' textAlign='center'>Exam Schedules</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='16.6%' textAlign='center'>Library Items</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='16.6%' textAlign='center'>Live Classes</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='16.6%' textAlign='center'>Announcements</Text>
           
            </Box>
            <Box
                w='100%'
                border='1px solid rgba(0, 0, 0, 0.1)'
                boxShadow='0px 4px 10px rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                px='1rem'
                mb='1rem'
                bgColor='white'
            >
                {statisticParticipantsData.users===undefined? (
              <Box />
            ) : (
                    statisticParticipantsData.users.map((user, idx) => <Box
                        w='100%'
                        d='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        py='1rem'
                        fontSize='15px'
                        color='#000000'
                        fontWeight='600'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                        key={idx}
                    >
                        <Text width='16.6%'>{user.first_name}{user.last_name}</Text>
                        <Text width='16.6%' textAlign='center'>{user.no_of_schedules}</Text>
                        <Text width='16.6%' textAlign='center'>{user.exam_schedule_answers} / {user.exam_schedules}</Text>
                        <Text width='16.6%' textAlign='center'>{user.library_items}</Text>
                        <Text width='16.6%' textAlign='center'>{user.no_of_meetings}</Text>
                        <Text width='16.6%' textAlign='center'>{user.no_of_announcements}</Text>
                    </Box>
                    )
                    )
                }
            </Box>
          </Box>
        </Box>
    </Box>
  );
}
